export default __webpack_public_path__ + "static/media/android.774da94c.mp4";